import React from 'react';
import Payment from './Payment';
import AddAddress from './AddAddress';
import Location from '../location/Location';
import AddressList from './AddressList';
import Shipment from './Shipment';
import OrderConfirmation from './OrderConfirmation';
import HBMoneyRechargeWeb from '../../../feature/account/Wallet/HBMoneyRechargeWeb';

export const checkoutPrefix = 'co';

const checkoutRoutes = [
  {
    path: `/${checkoutPrefix}/available-address`, // Address List
    component: AddressList,
    key: 'addressList',
    exact: true,
    isPrivate: true,
  },
  {
    path: `/${checkoutPrefix}/new-address/:addressId?`, // New address form with map.
    component: AddAddress,
    key: 'addAddress',
    exact: true,
    isPrivate: true,
  },
  {
    path: `/${checkoutPrefix}/location`, // Search for location
    component: Location,
    key: 'location',
    exact: true,
    isPrivate: true,
  },
  {
    path: `/${checkoutPrefix}/shipment`, // Shipment and slot selection
    component: Shipment,
    key: 'shipment',
    exact: true,
    isPrivate: true,
  },
  {
    path: `/${checkoutPrefix}/payment`, // Final payment page.
    component: Payment,
    key: 'payment',
    exact: true,
    isPrivate: true,
  },
  {
    path: `/${checkoutPrefix}/order/:orderNo`, // Final payment page.
    component: OrderConfirmation,
    key: 'orderConfirmation',
    exact: true,
    isPrivate: true,
  },
  {
    path: `/${checkoutPrefix}/vxl-money/recharge`, // Final payment page.
    component: HBMoneyRechargeWeb,
    key: 'rechargeForOrder',
    exact: true,
    isPrivate: true,
  },
];

export const getCheckoutRoute = key => {
  console.log('-------KEY CHECK-------', key);
  if (key) {
    const route = checkoutRoutes.find(route => route.key === key);
    console.log('-------ROUTE CHECK----------', route);
    if (route) return route.path;
  }
  return `/${checkoutPrefix}/`;
};

export default checkoutRoutes;
